/**
 * 面对面赠券
 */
export const FACEINTEGRAL_MEMBER_SEARCH = {
  name: '面对面积分—查询会员详情',
  api: '${FACE2FACE}/app-face/api/D/external/customer/info',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#9a8ee16256f576474ec24d0860ea6b94',
};
export const FACEINTEGRAL_SCORE_GET = {
  name: '面对面积分—赠积分',
  api: '${FACE2FACE}/app-face/app/score/get',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#56dd9434fd982a153e4e55339456e998',
};


